import withFeatureBranch from '@wix/da-react-context/pkg/flags/withFeatureBranch';
import ShopAll from './ShopAll';
import ShopAllBranched from '../ShopAll.deviation_gruser';
import ShopAllContainer from './ShopAll.container';

export default withFeatureBranch({
  gruser_shop: ShopAllBranched,
})(ShopAllContainer(ShopAll));
